var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBg2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 960 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_17",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 960,
    height: 1080
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1080,
    fill: "#1E293B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 1080,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.00012207,
    cy: -0.595581,
    r: 440.068,
    stroke: "#242F41",
    strokeWidth: 184
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 976,
    r: 440.068,
    stroke: "#242F41",
    strokeWidth: 184
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg2);
export default __webpack_public_path__ + "static/media/loginBg2.c2fec37dd51b6460b8b5dd21dfdf41a6.svg";
export { ForwardRef as ReactComponent };